import { FC, ReactNode } from 'react'
import {
  ReservationExportReservations,
  ReservationExportReservationsType,
} from './ExportReservations'

const Reservation: FC & ReservationExportReservationsType = (): ReactNode => (
  <></>
)

Reservation.ExportReservations = ReservationExportReservations

export default Reservation
